<template>
  <v-row justify="center">
    <v-dialog v-model="open" width="600px" scrollable>
      <v-card>
        <v-toolbar elevation="0">
          <v-toolbar-title class="ml-4 text-subtitle">
            <v-icon color="primary" class="mr-2">mdi-folder-outline</v-icon>
            Adicionar {{ movedItems.length }} itens ao DRM
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn
              :disabled="isFetching"
              icon
              @click="handleClose()"
              class="mr-2"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-toolbar elevation="0" class="mx-5 mb-4">
          Explicação oq acontece qdo adicionar
        </v-toolbar>
        <v-card-text style="height: 450px">
          <v-list dense>
            <v-list-item-group v-model="selectedGroup">
              <v-list-item
                v-for="group in toBeSelectedGroups"
                :key="group.id"
                :value="group"
                @click="handleRowClick(group)"
              >
                <v-list-item-icon>
                  <v-icon v-text="'mdi-security'" color="primary"></v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title v-text="group.name"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card-text>
        <v-card-actions class="px-8 py-4">
          <v-spacer></v-spacer>
          <v-btn class="px-6" text @click="handleClose" :disabled="isFetching">
            {{ $t('message.cancel') }}
          </v-btn>
          <v-btn color="primary" @click="handleMove" :loading="isFetching">
            <span class="px-5">{{ $t('message.add') }}</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'
import drmApi from '@/services/drmApi'

export default {
  name: 'DrmAddGroupModal',
  components: {},
  data: () => ({
    open: false,
    isFetching: false,
    selectedGroup: null,
    movedItems: [],
    toBeSelectedGroups: [],
  }),
  mounted() {
    this.$root.$on('drmAddGroupModal', (selectedItems) => {
      Object.assign(this.$data, this.initialState())
      this.movedItems = selectedItems
      this.open = true
      this.loadDrmGroups()
    })
  },
  beforeDestroy() {
    this.$root.$off('moveModal')
  },
  methods: {
    ...mapActions('user', ['editFolder', 'addFolder']),
    ...mapMutations('user', ['UPDATE_GLOBAL_SNACKBAR']),
    async loadDrmGroups() {
      try {
        let ret = await drmApi.getDrmGroups()
        this.toBeSelectedGroups = ret.data
      } catch (e) {
        console.log('e', e)
      }
    },
    handleRowClick(group) {
      console.log('selected group', group)
    },
    async handleMove() {
      this.isFetching = true
      try {
        const videosIds = this.movedItems.map((video) => video.id)
        let ret = await drmApi.drmUpdateVideos(this.selectedGroup.id, {
          videos: {
            action: 'increment',
            video_ids: videosIds,
          },
        })
        console.log('ret', ret)
      } catch (e) {
        console.log('e', e)
      }
      this.isFetching = false
      this.handleClose()
    },
    handleClose() {
      this.open = false
    },
    initialState() {
      return {
        open: false,
        isFetching: false,
        selectedGroup: null,
        movedItems: [],
      }
    },
  },
}
</script>

<style></style>
